import './style.scoped.css';
import { useCallback } from 'react';
import News from 'src/models/News';
import { sendOpenNewWebview } from 'src/utils';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { useTranslation } from 'react-i18next';
dayjs.extend(customParseFormat);

interface NewsItemProps {
  data: News;
}
const NewsItem = (props: NewsItemProps) => {
  const { data } = props;
  const { t } = useTranslation();

  const _handleClick = useCallback(() => {
    sendOpenNewWebview(data);
  }, [data]);

  const _getDisplayPostTime = (): string => {
    if (!data.postTime) return null;
    return dayjs(data.postTime).format(t('date_format1'));
  };

  return (
    <div className={'item'} key={data.id} onClick={_handleClick}>
      <div className={`data`}>
        <img className={'itemImage'} src={data.photo} />
        <div className={'contentContainer'}>
          <div className="blockTitle name">{data.name}</div>
          <div className="postTime">{_getDisplayPostTime()}</div>
        </div>
      </div>
    </div>
  );
};
export default NewsItem;
